module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "global-white.40787e15.svg";